module.exports = __webpack_public_path__ + "media/上台音乐.9a7b5760.mp3";